import { appStore } from '../store/app/app';

export const selectEmbeddedData = () => {
    return {
        windowData: appStore.windowInitialData,
        callData: appStore.callInitialData,
    };
};

export const selectEmbeddedInitialData = () => {
    const data = selectEmbeddedData();
    return data.callData;
};

export const selectEmbeddedWindowData = () => {
    const data = selectEmbeddedData();
    return data.windowData;
};

export const selectIsEmbeddedMode = (): boolean => Boolean(appStore.windowInitialData?.descriptor);

export const selectCurrentUser = () => {
    const data = selectEmbeddedData();
    return data.callData?.initialData.currentUserInfo;
};

export const selectCallConfig = () => {
    const data = selectEmbeddedData();
    return data.callData?.config;
};

export const selectIsDontShowMeetPreview = () => {
    const data = selectEmbeddedData();
    return data.callData?.config.isDontShowMeetPreview;
};

export const selectIsVKSAudioEnabled = () => {
    const data = selectEmbeddedData();
    return data.callData?.config.isVKSAudioEnabled;
};

export const selectIsVKSVideoEnabled = () => {
    const data = selectEmbeddedData();
    return data.callData?.config.isVKSVideoEnabled;
};

export const selectRequiresWaitingRoomRejoin = (): boolean =>
    Boolean(selectEmbeddedInitialData()?.accountSettings?.requiresWaitingRoomRejoin);
